import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container, ModalBody, Modal } from 'reactstrap';
import { Card } from 'reactstrap';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import { requisition_create } from '../../api/requisition';
import { useNavigate } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import {formatValueWithCommas} from '../helper'

const AddPurchaseRequisition = () => {
    const location = useLocation();
    const { rows } = location.state || { rows: [] };
    const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const navigate = useNavigate();

    const groupByProduct = (rows) => {
        // Create a map to store aggregated product information
        const productMap = new Map();
    
        // Process each row
        rows.forEach(row => {
            // Handle main product
            const mainProduct = row.productObj;
            if (mainProduct && mainProduct.value) {
                if (!productMap.has(mainProduct.value)) {
                    productMap.set(mainProduct.value, {
                        label: mainProduct.label,
                        value: mainProduct.value,
                        quantity: 0,
                        dpValue: mainProduct.Dp,
                    });
                }
                // Update the quantity of the main product
                productMap.get(mainProduct.value).quantity += parseInt(row.quantity || 0, 10);
            }
    
            // Handle sub-products
            (row.subRows || []).forEach(subRow => {
                const subProduct = subRow.productObj;
    
                if (subProduct && subProduct.value) {
                    if (!productMap.has(subProduct.value)) {
                        productMap.set(subProduct.value, {
                            label: subProduct.label,
                            value: subProduct.value,
                            quantity: 0,
                            dpValue: subProduct.Dp,
                        });
                    }
                    // Update the quantity of the sub-product
                    productMap.get(subProduct.value).quantity += parseInt(subRow.quantity || 0, 10);
                }
            });
        });
    
        // Convert the map to an array and add additional fields
        return Array.from(productMap.values()).map((product, index) => ({
            ...product,
            Sl_No: index + 1,
            Value: product.dpValue * product.quantity,
        }));
    };

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };

    const groupedRows = groupByProduct(rows);

    const totalQuantity = groupedRows.reduce((acc, row) => acc + row.quantity, 0);
    const totalValue = groupedRows.reduce((acc, row) => acc + row.Value, 0);

    const prepareDataForAPI = (rows) => {
        let requisitionData = [];

        rows.forEach(row => {
            const executiveId = row.executiveObj.value;
            const items = row.subRows.map(subRow => ({
                total_qty: parseInt(subRow.quantity),
                value: parseInt(subRow.value),
                item_name:  subRow.productObj.label,
                item_no:   subRow.productObj.value,
                p_type: subRow.productObj.Ptype,
                vertical: subRow.productObj.Vertical,
                itemseg:  subRow.productObj.Itemseg,
                category:subRow.productObj.Category,
                dp: subRow.productObj.Dp,
                mop:subRow.productObj.Mop,
                vcode:subRow.productObj.vcode,
                vname:subRow.productObj.vname,
                vtype: subRow.productObj.vtype,

            }));
            const mainProduct = row.productObj;
            
            if (mainProduct && mainProduct.value) {
                items.push({
                    total_qty: parseInt(row.quantity),
                    value: parseInt(row.value),
                    item_name: mainProduct.label,
                    item_no: mainProduct.value,
                    p_type: mainProduct.Ptype,
                    vertical: mainProduct.Vertical,
                    itemseg: mainProduct.Itemseg,
                    category: mainProduct.Category,
                    dp: mainProduct.Dp,
                    mop: mainProduct.Mop,
                    vcode: mainProduct.vcode,
                    vname: mainProduct.vname,
                    vtype: mainProduct.vtype
                });
            }
            const req_total = items.reduce((acc, item) => acc + item.value, 0)
            const req_item_count = items.reduce((acc, item) => acc + item.total_qty, 0)

            requisitionData.push({
                user_id: executiveId,
                req_total,
                req_item_count,
                items: items,
            });
        });

        return requisitionData;
    };

    const submitRequisition = async () => {
        try {
            const requestData = prepareDataForAPI(rows);
            closeModal(); // Closing the modal when 'No' button is clicked
            setIsLoading(true)
            const createReq = await requisition_create({requisition_data: requestData})


            if(createReq.statusCode === 201) {
 
             setIsOpenSweetAlert(true);
 
            }
 

        }
        catch (e){
            console.log(e)
            toast.error('Error in creating Purchase requisition')
        }
        finally {
            setIsLoading(false); // Reset loading state after operation completes
        }
    };

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
        navigate("/purchase-manager-approval-requisition");
    };

    const handleNavigate = () => {
        navigate('/purchase-manager/create-requisition', { state: { prevRoute: '/purchase-manager/add-requisition' }});
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                {isLoading && ( // Conditional rendering of loader
                <div className="loader-container">
                    <LinearProgress />
                </div>
                )}
                    <div className='mb-3' style={{ fontSize: '20px', fontWeight: '500' }}>
                        <span className='me-2' onClick={handleNavigate}><ArrowBackIcon /></span>
                        <span>Requisition</span>
                    </div>
                    <Card>
                        <CardBody>
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product Name</th>
                                            <th>Quantity</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        {groupedRows.map(row => (
                                            <tr key={row.value}>
                                                <td>{row.Sl_No}</td>
                                                <td>{row.label}</td>
                                                <td>{row.quantity}</td>
                                                <td>{formatValueWithCommas(row.Value)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="2">Total :</th>
                                            <td>{totalQuantity}</td>
                                            <td>{formatValueWithCommas(totalValue)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                    <div className='mb-2' style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', marginRight: '8px', marginBottom: '3px', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
                        <button className="save_button" variant="contained" onClick={openModal}>Submit</button>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3 sumbit_requisition_header'>Do You Want To Submit This Requisition</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i className="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    <div>
                        <div>
                            <p className='mb-0 sumbit_requisition_text'>If 'Yes', then you won't be able to modify or edit your request. If 'No', then you can continue your modification.</p>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" onClick={() => {
                    submitRequisition();
                }}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={closeModal}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title='Requisition created successfully'
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
}

export default AddPurchaseRequisition;
